// @ts-nocheck
import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import className from "./PulldownList.module.scss";
import PullDownItem from "./PullDownItem";
import PullDownItemGroup from "./PullDownItemGroup";
import { useWorkflowBootedAtFormat } from "../../../hooks/useWorkflowBootedAtFormat";
import { getImageUrl } from "../../../commons/assets_path";
import { useTranslation } from "react-i18next";
import { apiFetchClientTimezone } from "../../../api/api";

export const BasicPulldownListOld = ({ outputs, onClickList, isSuggestClose, workflowBootedAt, dateTimeFormat }) => {
  const { t } = useTranslation();
  const workflowUrl = window.location.href.replace(/\/workflow_templates\/(\d+)\/.*/, "/workflow_templates/$1");
  // 国内クライアントが多いので、国内のタイムゾーンを設定（表示だけなので問題ない）
  const [timeZone, setTimeZone] = useState("Asia/Tokyo");
  const fetchTimeZone = async () => {
    const result = await apiFetchClientTimezone();
    if (result?.status === 200) {
      setTimeZone(result.data.timezone);
    }
  };

  useEffect(() => {
    fetchTimeZone();
  }, []);

  return (
    <div className={className.pulldownScroll} style={{ margin: "0 12px" }}>
      <>
        <PullDownItemGroup
          key="workflow_booted_at"
          title={t("BasicPulldownList.フローボット起動日時")}
          image=""
          isSuggestClose={isSuggestClose}
        >
          {dateTimeFormat.map((format) => (
            <PullDownItem
              key={format}
              value={t("BasicPulldownList.フローボット起動日時_format", { format })}
              onClick={onClickList}
            >
              <dl className={className.outputDisplay}>
                <dt className={className.outputTitle}>{format}</dt>
                <dd className={className.outputDescription}>
                  {useWorkflowBootedAtFormat(timeZone, workflowBootedAt, format)}
                </dd>
              </dl>
            </PullDownItem>
          ))}
        </PullDownItemGroup>
        <PullDownItemGroup key="workflow_url" title="URL" image="" isSuggestClose={isSuggestClose}>
          {outputs?.map(({ operation_name, icon_type, icon_path, outputs }) =>
            outputs?.map(({ id, display_name, test_value }) => (
              <PullDownItem key={id} value={display_name} onClick={onClickList} style={{ maxWidth: "436px" }}>
                <dl className={className.outputDisplay}>
                  <dt className={className.outputTitle}>
                    {
                      <img
                        src={icon_type === "service" ? icon_path : getImageUrl(icon_path)}
                        className={className.icon}
                      />
                    }
                    {display_name}
                  </dt>
                  <dd className={className.outputDescription}>
                    {test_value !== null ? test_value.replace(/\[,\]/g, ",") : ""}
                  </dd>
                </dl>
              </PullDownItem>
            )),
          )}
          <PullDownItem
            value={t("BasicPulldownList.フローボットURL")}
            onClick={onClickList}
            style={{ maxWidth: "436px" }}
          >
            <dl className={className.outputDisplay}>
              {<img src={getImageUrl("images/icons/yoom_icon.png")} className={className.icon} />}
              <dt className={className.outputTitle}>{t("BasicPulldownList.フローボットURL")}</dt>
              <dd className={className.outputDescription}>{workflowUrl}</dd>
            </dl>
          </PullDownItem>
        </PullDownItemGroup>
      </>
    </div>
  );
};

BasicPulldownListOld.propTypes = {
  outputs: PropTypes.arrayOf(
    PropTypes.shape({
      operation_name: PropTypes.string,
      operation_icon_path: PropTypes.string,
      outputs: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number.isRequired,
          display_name: PropTypes.string.isRequired,
          test_value: PropTypes.string,
        }).isRequired,
      ).isRequired,
    }).isRequired,
  ).isRequired,
  onClickList: PropTypes.func,
  isSuggestClose: PropTypes.bool,
  workflowBootedAt: PropTypes.string.isRequired,
  dateTimeFormat: PropTypes.arrayOf(PropTypes.string).isRequired,
};
